import {addValidator} from 'redux-form-validators';
import {countryMapping, getCountryNames} from '../../utils/country-mapping';

const mappings = Object.keys(countryMapping);

export default addValidator({
  // eslint-disable-next-line consistent-return
  validator: ({projectCountries}, value) => {
    if (
      typeof value === 'string' &&
      !mappings.filter(c => getCountryNames(projectCountries).includes(c)).includes(value)
    ) {
      return {
        id: 'validation.country-not-found'
      };
    }
  }
});



// WEBPACK FOOTER //
// ./validators/units/country-name.js